import React, { useEffect, useState, useCallback } from 'react'
import Slider from "react-slick";
import 'react-animated-slider/build/horizontal.css';
import 'aos/dist/aos.css';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs'
import { Parallax } from 'react-parallax';
import { useMediaQuery } from "react-responsive";
import { VscArrowDown } from 'react-icons/vsc'
import { Link } from 'react-scroll';
import { useContactModal } from '../../Context/ContactModalContext';

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style, display: 'block', position: 'absolute', right: '20px', top: '45%', zIndex: 1, cursor: 'pointer' }}
            onClick={onClick}
        >
            <BsChevronRight size={32} color="white" />
        </div>
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style, display: 'block', position: 'absolute', left: '20px', top: '45%', zIndex: 1, cursor: 'pointer' }}
            onClick={onClick}
        >
            <BsChevronLeft size={32} color="white" />
        </div>
    );
}

function HomeSliderReactAnimated() {
    const isBigScreen = useMediaQuery({ query: "(min-width: 1023px)" });
    const isMobile = useMediaQuery({ maxWidth: 768 });

    // Get showContactPopUp from context — cancels 60s timer automatically
    const { showContactPopUp } = useContactModal();

    const images = [
        {
            url: isMobile ? "images/1.jpeg" : "images/6.jpeg",
            title: `Ziva Interiors - To brighten your home`,
            subTitle: "To brighten your home",
            mainTitle: "Transform Your Home to Life with our Stunning Interior Design",
            id: 0,
        },
        {
            url: "images/2.jpeg",
            title: "Elevate Your Home or Business with Expert Design Solutions",
            mainTitle: "Listen to your dreams and we will listen to you.",
            id: 1,
        },
        {
            url: "images/3.jpeg",
            title: "Change your Life-Style via Ziva-Style",
            mainTitle: "Elevate Your Home with Customized Design Services",
            id: 2,
        },
    ];

    const [isVisible, setIsVisible] = useState(true);

    const listenToScroll = () => {
        let heightToHideFrom = 100;
        const winScroll =
            document.body.scrollTop || document.documentElement.scrollTop;
        if (winScroll > heightToHideFrom) {
            isVisible && setIsVisible(false);
        } else {
            setIsVisible(true);
        }
    };

    const listenScroll = useCallback(() => {
        window.addEventListener("scroll", listenToScroll);
        return () => window.removeEventListener("scroll", listenToScroll);
    }, [listenToScroll]);

    useEffect(() => {
        listenScroll();
    }, []);

    const settings = {
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 10000,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />
    };

    const callToActionBtn =
        "border-white text-white px-10 hover:text-black uppercase hover:bg-white transitions lg:px-4 lg:py-3 py-2 md:py-3 border-2 text-sm bg-opacity-30 tracking-[2px]";
    const titleText =
        "xl:lg:md:text-6xl sm:text-4xl xs:text-3xl text-3xl w-[80%] font-ivy_mode captilazie text-main font-thin tracking-[6px] xs:tracking-[2px]";

    return (
        <>
            <div>
                <Slider {...settings}>
                    {images.map((item, index) => (
                        <Parallax
                            bgImage={item.url}
                            renderLayer={() => (
                                <div style={{ position: 'absolute', background: `rgba(0,0,0,0.3)`, left: '0%', top: '0%', width: "100%", height: "100%" }} />
                            )}
                            bgImageAlt={`image-${index}`}
                            strength={500}
                            key={item.id}
                        >
                            <div className="h-screen">
                                <div className="absolute xl:pl-24 sm:pl-32 px-10 mx-5 xl:top-36 lg:top-36 top-10 bottom-0 right-0 left-0 flex flex-col justify-center lg:gap-8 md:gap-5 gap-2">
                                    <div>
                                        <h1 className={titleText}>{item.title}</h1>
                                    </div>
                                    <div className="flex items-center font-thin text-white lg:md:text-3xl sm:text-2xl text-xl lg:tracking-[4px] tracking-[2px] lg:w-[50%] md:w-[70%] xs:w-[80%] sm:w-[90%] w-[100%]">
                                        {item.mainTitle}
                                    </div>
                                    <div className={`${item?.title && item?.mainTitle ? "mt-2" : "lg:mt-[250px] md:mt-[220px] sm:mt-[200px] mt-[120px]"}`}>
                                        <button onClick={showContactPopUp} className={callToActionBtn}>
                                            Get a Free Design Consultation
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Parallax>
                    ))}
                </Slider>

                {isVisible && (
                    <div className='sticky flex flex-col bottom-6 justify-center items-center left-1/2 right-1/2 text-white'>
                        <h1 className='text-2xl w-[175px] mb-5'>Scroll To Explore</h1>
                        <Link to={`about`} spy={true} smooth={true} offset={isBigScreen ? -120 : -170} duration={500}>
                            <div className='w-10 h-10 animate-bounce rounded-full border border-white flex justify-center items-center hover:cursor-pointer'>
                                <VscArrowDown size={20} />
                            </div>
                        </Link>
                    </div>
                )}
            </div>
            {/* No Modal here — handled solely by ContactModalContext */}
        </>
    );
}

export default HomeSliderReactAnimated;